{
  "Accessibility Menu": "የተደረሰ ምናሌ",
  "Reset settings": "ቅንብሮችን ዳግም አስጀምር",
  "Close": "ዝጋ",
  "Content Adjustments": "የይዘት ማስተካከያዎች",
  "Adjust Font Size": "የፊደል መጠን አስተካክል",
  "Highlight Title": "ርዕስን አበራ",
  "Highlight Links": "አገናኞችን አበራ",
  "Readable Font": "ተነባቢ ፊደል",
  "Color Adjustments": "የቀለም ማስተካከያዎች",
  "Dark Contrast": "ጨለማ መለያየት",
  "Light Contrast": "ብርሃን መለያየት",
  "High Contrast": "ከፍተኛ መለያየት",
  "High Saturation": "ከፍተኛ መጠን ያለው ቀለም",
  "Low Saturation": "ዝቅተኛ መጠን ያለው ቀለም",
  "Monochrome": "አንደኛ ቀለም",
  "Contrast": "ልዩነት",
  "Invert Colors": "ቀለሞችን መቀየር",
  "Tools": "መሳሪያዎች",
  "Reading Guide": "የንባብ መመሪያ",
  "Stop Animations": "አንዲሶችን አቁም",
  "Big Cursor": "ትልቅ አዝራር",
  "Increase Font Size": "የፊደል መጠን አሳድግ",
  "Decrease Font Size": "የፊደል መጠን አሳንስ",
  "Letter Spacing": "የፊደል ክፍተት",
  "Line Height": "የመስመር ከፍታ",
  "Font Weight": "የፊደል ክብደት",
  "Dyslexia Font": "የዲስሌክሲያ ፊደል",
  "Language": "ቋንቋ",
  "Open Accessibility Menu": "የተደረሰ ምናሌን ክፈት",
  "Widget Settings": "የዊጄት ቅንብሮች",
  "Widget Position": "የዊጄት ቦታ",
  "Top Left": "ላይ ግራ",
  "Top Center": "ላይ መሀከል",
  "Top Right": "ላይ ቀኝ",
  "Center Left": "መሀከል ግራ",
  "Center Right": "መሀከል ቀኝ",
  "Bottom Left": "ታች ግራ",
  "Bottom Center": "ታች መሀከል",
  "Bottom Right": "ታች ቀኝ",
  "Screen Reader": "የስክሪን አንባቢ",
  "Voice Navigation": "ድምፅ አሰሳ",
  "Custom Color": "ብጁ ቀለም",
  "Change the site's colors": "የጣቢያውን ቀለሞች ቀይር",
  "Backgrounds": "ዳራዎች",
  "Headings": "ርዕሶች",
  "Contents": "ይዘቶች",
  "Reset colors": "ቀለሞችን ዳግም አስጀምር",
  "Image Desaturation": "የምስል ቀለም መቀነስ",
  "Search languages": "ቋንቋዎችን ፈልግ",
  "No languages found": "ምንም ቋንቋ አልተገኘም",
  "Accessibility Profiles": "የተደራሽነት መገለጫዎች",
  "Motor Impaired": "የእንቅስቃሴ እጥረት",
  "Big cursor, voice navigation, and no animations.": "ትልቅ መጠቆሚያ፣ የድምጽ አሰሳ እና እንቅስቃሴ የለም።",
  "Blind": "ታዳሽ",
  "Screen reader helpers with higher contrast.": "ከፍተኛ ግራጫ ያላቸው የስክሪን አንባቢ እርዳታዎች።",
  "Color Blind": "የቀለም ችግር",
  "High contrast palette with desaturated media.": "ከፍተኛ ግራጫ ያለው ፓሌት እና የተቀነሰ ቀለም ሚዲያ።",
  "Dyslexia": "ዲስሌክሲያ",
  "Friendly font, extra spacing, stronger weight.": "ተስማሚ ፊደል፣ ተጨማሪ ክፍተት እና ጠንካራ ውፍረት።",
  "Low vision": "ዝቅተኛ እይታ",
  "Dark contrast and 130% magnification.": "ጥቁር ግራጫ እና 130% ማታበር።",
  "Cognitive & Learning": "አእምሮአዊ እና መማር",
  "Highlights key sections and enables voice help.": "ዋና ክፍሎችን ያበራ እና የድምጽ እርዳታን ያንቃል።",
  "Seizure & Epileptic": "የእብጠት ችግር",
  "Stops animations and desaturates imagery.": "እንቅስቃሴዎችን ያቆማል እና ምስሎችን ያቀናል።",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "የንባብ መሪ፣ የተቀረጹ አገናኞች እና ተዛማጅ ቀለም ፓሌት።",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
